import * as pdfjsLib from "pdfjs-dist";

// Set up the worker with bundled version instead of external CDN
if (pdfjsLib.GlobalWorkerOptions) {
  // Use the worker directly from node_modules using the correct file extension
  pdfjsLib.GlobalWorkerOptions.workerSrc = require("pdfjs-dist/build/pdf.worker.min.js");
}

export const importPdfJS = () => {
  return Promise.resolve(pdfjsLib);
};
